/**
 * Return with the price increased with the regioCharge
 *
 * @param price
 * @param product
 * @returns
 */
export const getPriceWithRegioCharge = (price: number, regioCharge: number = 0): number =>
    price + regioCharge;
